import {routingAddresses} from "./routing";
import {IUserStore} from "../administration/stores/userStore";

export default class RoutingUtils {
    public static getTcrAddress(userStore: IUserStore, orderId: string): string {
        return userStore.canModifyTcr ? `${routingAddresses.order.modifyTcr}/${orderId}` : `${routingAddresses.order.tcr}/${orderId}`;
    }
}